define([
    "./monitoringLGPDModule",
], function (monitoringLGPDModule) {
    "use strict";

    monitoringLGPDModule.config(["lgpdApiByArtifactProvider", function (lgpdApiByArtifact) {
        lgpdApiByArtifact.addArtifactApi("monitoring", "monitoringLgpdApi")
    }]);
});